<!-- 问卷创建成功页面 -->
<template>
  <div class="share-common" :class="'page' + pageIndex">
    <div v-show="pageIndex === 0">
      <div class="padding1">
        <!--  <putStatus
          icon="task-ok"
          msg="问卷发布成功"
          info="找不到样本？58问卷还可以帮你精准投放"
        ></putStatus> -->
        <shareQrcode isTitleH2 title="您可分享以下链接或二维码，邀请他人作答"></shareQrcode>
        <putCard @put="put" ref="putCard" showTitleH2 title="没人作答？ 58来帮你，点击下方“一键投放”即可获得更多回答"></putCard>
      </div> 
    </div>
    <putStatus class="padding1" v-if="pageIndex === 1" hasBtn></putStatus>
  </div>
</template>

<script>
import putStatus from "./put-status.vue";
import putCard from "./put-card.vue";
import shareQrcode from "./share-qrcode.vue";

export default {
  name: "share-common",
  data() {
    return {
      pageIndex: 0,
    };
  },
  props: {
    hideStatus: {
      type: Boolean,
      default: false,
    },
  },
  components: { putStatus, putCard, shareQrcode },
  mounted() {
    this.$refs.putCard.getPutStatus();
  },
  methods: {
    put() {
      this.pageIndex = 1;
    },
  },
};
</script>
<style lang='scss' scoped>
.share-common {
  & > div {
    border-radius: 4px;
  }
  .page-2 {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .title {
    height: 20px;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
  }
}
.page1 {
  width: 100%;
  height: 100%;
  min-height: 450px;
  background-color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/shareCommon/index.vue